import AccountIndex from "../../pages/dashboard/settings/account/AccountIndex";
import AnnouncementIndex from "../../pages/dashboard/settings/annoucement/AnnouncementIndex";
import ApprovalSettingsIndex from "../../pages/dashboard/settings/approval/ApprovalSettingsIndex";
import ExchangeRateHistoryIndex from "../../pages/dashboard/settings/exchange-rate/ExchangeRateHistory";
import ExchangeRateIndex from "../../pages/dashboard/settings/exchange-rate/ExchangeRateIndex";
import manageFeautureIndex from "../../pages/dashboard/settings/manage-feature/ManageFeatureIndex";
import NotificationIndex from "../../pages/dashboard/settings/notification/NotificationIndex";
import ProfileIndex from "../../pages/dashboard/settings/profile/ProfileIndex";
import { ALL_ROUTES } from "../AllRoutes";

export const settings_all_routes_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_SETTINGS_EXCHANGE_RATE,
    element: ExchangeRateIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_SETTINGS_EXCHANGE_RATE_HISTORY,
    element: ExchangeRateHistoryIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_SETTINGS_PROFILE,
    element: ProfileIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_SETTINGS_ACCOUNT,
    element: AccountIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_SETTINGS_ANNOUNCEMENT,
    element: AnnouncementIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_SETTINGS_NOTIFICATION,
    element: NotificationIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_SETTINGS_MANAGE_FEATURE,
    element: manageFeautureIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_SETTINGS_APPROVAL,
    element: ApprovalSettingsIndex,
  },
];
